import { backofficeDocumentation } from './backofficeDocumentation';
import { directOnrampFlowDocumentation } from './directOnrampFlowDocumentation';
import { getStartedDocumentation } from './getStartedDocumentation';
import { integrationDocumentation } from './integrationDocumentation';
import { onrampDocumentation } from './onrampDocumentation';
import { payOrdersDocumentation } from './payOrdersDocumentation';
import { platformsDocumentation } from './platformsDocumentation';
import { processingFlowDocumentation } from './processingFlowDocumentation';
import { PageText } from './types';

export const documentation: Array<PageText> = [
  ...getStartedDocumentation,
  ...integrationDocumentation,
  ...payOrdersDocumentation,
  ...onrampDocumentation,
  ...processingFlowDocumentation,
  ...directOnrampFlowDocumentation,
  ...platformsDocumentation,
  ...backofficeDocumentation,
];

export {
  getStartedDocumentation,
  integrationDocumentation,
  payOrdersDocumentation,
  onrampDocumentation,
  processingFlowDocumentation,
  directOnrampFlowDocumentation,
  platformsDocumentation,
  backofficeDocumentation,
  type PageText,
};
